import { 
    GET_APPROVERS_LIST, 
    SET_APPROVERS_LIST,
    SAVE_OUT_OF_OFFICE_SETTING,
    IS_OUT_OF_OFFICE_SAVED,
    GET_CURRENT_OOO_SETTINGS,
    SET_CURRENT_OOO_SETTINGS, 
    SAVE_OUT_OF_OFFICE_SETTING_PROFILE,
    IS_OUT_OF_OFFICE_SAVED_PROFILE,
    GET_CURRENT_OOO_SETTINGS_PROFILE,
    SET_CURRENT_OOO_SETTINGS_PROFILE,
    GET_VALIDATE_BACKUP_APPROVER,
    SET_VALIDATE_BACKUP_APPROVER
} from "./OutOfOfficeTypes";

const getApproversList = (payload: any) => ({type: GET_APPROVERS_LIST, payload})
const setApproversList = (response: any) => ({type: SET_APPROVERS_LIST, response})

const saveOutOfOfficeSetting = (payload: any) => ({type: SAVE_OUT_OF_OFFICE_SETTING, payload})
const setIsOutOfOfficeSaved = (response: any) => ({type: IS_OUT_OF_OFFICE_SAVED, response})


const getCurrentSettings = (payload: any) => ({type: GET_CURRENT_OOO_SETTINGS, payload})
const setCurrentSettings = (response: any) => ({type: SET_CURRENT_OOO_SETTINGS, response})

const saveOutOfOfficeSettingProfile = (payload: any) => ({type: SAVE_OUT_OF_OFFICE_SETTING_PROFILE, payload})
const setIsOutOfOfficeSavedProfile = (response: any) => ({type: IS_OUT_OF_OFFICE_SAVED_PROFILE, response})


const getCurrentSettingsProfile = (payload: any) => ({type: GET_CURRENT_OOO_SETTINGS_PROFILE, payload})
const setCurrentSettingsProfile = (response: any) => ({type: SET_CURRENT_OOO_SETTINGS_PROFILE, response})

const getValidateBackUpApprover = (payload: any, page?: any) => ({type: GET_VALIDATE_BACKUP_APPROVER, payload, page})
const setValidateBackUpApprover = (response: any) => ({type: SET_VALIDATE_BACKUP_APPROVER, response})

export {
    getApproversList,
    setApproversList,
    saveOutOfOfficeSetting,
    setIsOutOfOfficeSaved,
    getCurrentSettings,
    setCurrentSettings,
    saveOutOfOfficeSettingProfile,
    setIsOutOfOfficeSavedProfile,
    getCurrentSettingsProfile,
    setCurrentSettingsProfile,
    getValidateBackUpApprover,
    setValidateBackUpApprover
}